import "core-js/modules/es.array.concat";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
 */
//come add footnotes
import React from 'react';
import { camelCase as _camelCase } from 'lodash-es';
import { BinaryWrapper, BodyTitle, Divider, MessageNotification, HtmlBlock, Marquee, MultiInfo, ShowHide, SplashCta, TextBlock, Include, Footnote, EmergencyMessage, Carousel, Sidebar, FeaturePromo, IAOffers, JumpCta, MultiColumn, Faq, NameValueWrapper, EnhancedTabs } from '../renderers';
import CmsContext from './CmsContext';
export var cmsComponentMap = {
  'Ad_Carousel': Carousel,
  'Ad_Banner': Carousel,
  'Ad_Sidebar': Sidebar,
  'Ad_Feature': FeaturePromo,
  'Ad': IAOffers,
  'Binary Wrapper': BinaryWrapper,
  'Body Title': BodyTitle,
  'CTA': JumpCta,
  'Divider': Divider,
  emergencyMessage: EmergencyMessage,
  'FAQ': Faq,
  Footnote: Footnote,
  'HTML Block': HtmlBlock,
  Include: Include,
  Marquee: Marquee,
  'Multi_Column': MultiColumn,
  'Message Notification': MessageNotification,
  'Multi Info': MultiInfo,
  'Name-Value Wrapper': NameValueWrapper,
  'Show-Hide': ShowHide,
  'Splash CTA': SplashCta,
  Text: TextBlock,
  'Tabs': EnhancedTabs
};
export var renderCmsComponent = function renderCmsComponent(componentData, i, content) {
  if (!componentData || !componentData.component) {
    return null;
  }

  var component = componentData.component;
  var schema = component.schema || '';
  var Component = cmsComponentMap[schema];
  return Component ? /*#__PURE__*/React.createElement(CmsContext.Consumers, {
    key: i,
    contexts: ['id', 'templateType']
  }, function (_ref) {
    var id = _ref.id,
        templateType = _ref.templateType;
    return /*#__PURE__*/React.createElement(Component, {
      className: 'clearFloat',
      key: "".concat(id, "_").concat(i),
      templateType: templateType,
      id: id,
      data: componentData,
      content: content
    });
  }) : null;
};
export var reactAttr = {
  accesskey: 'accessKey',
  autocapitalize: 'autoCapitalize',
  autocomplete: 'autoComplete',
  autofocus: 'autoFocus',
  autoplay: 'autoPlay',
  "class": 'className',
  colspan: 'colSpan',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  crossorigin: 'crossOrigin',
  datetime: 'dateTime',
  enctype: 'encType',
  formaction: 'formAction',
  frameborder: 'frameBorder',
  hreflang: 'hrefLang',
  htmlfor: 'htmlFor',
  'http-equiv': 'httpEquiv',
  maxlength: 'maxLength',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  referrerpolicy: 'referrerPolicy',
  rowspan: 'rowSpan',
  spellcheck: 'spellCheck',
  srclang: 'srcLang',
  tabindex: 'tabIndex'
};
export var getStylesFromNode = function getStylesFromNode(nodeStyles) {
  var reactStyles = {};

  if (nodeStyles) {
    for (var i = 0; i < nodeStyles.length; i++) {
      var rule = nodeStyles[i];
      reactStyles[_camelCase(rule)] = nodeStyles[rule];
    }
  }

  return reactStyles;
};
export default {
  cmsComponentMap: cmsComponentMap,
  renderCmsComponent: renderCmsComponent,
  reactAttr: reactAttr,
  getStylesFromNode: getStylesFromNode
};